import Layout from '@/layout'

// GIMMATEK 營運報表模組只保留 AI 服務人員績效（CNCY-10766）
export const operateDashboardRoutes = [
  {
    path: '/operate-dashboard',
    component: Layout,
    name: 'operateDashboard',
    alwaysShow: true,
    isGroup: true,
    meta: {
      title: '營運報表模組',
    },
    children: [
      {
        path: 'appointment-unit-analysis',
        name: 'BeautyAIAppointmentUnitAnalysis',
        component: () => import('@/views/BeautyAIAppointmentUnitAnalysis/BeautyAIAppointmentUnitAnalysis.vue'),
        meta: {
          title: 'AI 服務人員績效',
          action: 'admin.beautyAIAptUnitAnalysis.page',
        },
      },
      {
        path: 'appointment-unit-analysis/detail/:id',
        name: 'BeautyAIAppointmentUnitAnalysisDetail',
        hidden: true,
        component: () => import('@/views/BeautyAIAppointmentUnitAnalysisDetail/BeautyAIAppointmentUnitAnalysisDetail.vue'),
        meta: {
          title: 'AI 服務人員績效詳情',
          action: 'admin.beautyAIAptUnitAnalysis.page',
        },
      },
    ],
  },
]
